import generatePDF from "react-to-pdf";
import axiosInstance from "./api_helper";

const clientService = {
    
    search: async ({ query = '', page = 0, size = 1000 }) => {
        return axiosInstance.get('/api/clients/search', {
            params: { query, page, size }
        });
    },


    addClient: async (payload) => {
        return await axiosInstance.post('/api/clients/addClient', payload);
         
    },

    update: async (id, data) => {
        return axiosInstance.put(`/api/clients/${id}`, JSON.stringify(data));
    },
    
    inactivate: async (id) => {
        return axiosInstance.delete(`/api/clients/${id}`);
    },
  
    generatePDFReleve : async (payload) => {
        const response = await axiosInstance.post(`/api/clients/report`, payload, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
};

export default clientService;